import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/404/NotFoundPage'
import Login from '../pages/auth/Login'

export default function AuthRouter () {
    return (
        <Routes>
            <Route path="/" element={<Login />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="*" element={<NotFoundPage />}/>
        </Routes>
    )
}